import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { BREAKPOINT_VALUES_MAP, DEVICE_MAP } from 'constants/breakpoint';
export const getBreakpointsFromDevice = device => {
  const active = DEVICE_MAP[device];
  return _objectSpread({
    active
  }, Object.fromEntries(active.map(devices => [devices, true])));
};
export const getBreakpointsFromWidth = width => {
  const active = [];
  const breakpoints = Object.entries(BREAKPOINT_VALUES_MAP).reduce((accumulator, _ref) => {
    let [device, breakpoint] = _ref;
    const match = width >= breakpoint[0] && width <= breakpoint[1];
    if (match) active.push(device);
    accumulator[device] = match;
    return accumulator;
  }, {});
  return _objectSpread({
    active
  }, breakpoints);
};